import { styled } from '@mui/material'
import { LegacyRef, useMemo } from 'react'
import { TableConfig } from '../../../types/tableTypes'
// import useScrollBar from '../../../hooks/useScrollBar'
import RefLinkTableHeader from './RefLinkTableHeader'
import TableRow from './TableRow'
import CircularProgress from '@mui/material/CircularProgress'

type ReferralLinkTableProps<T> = {
	tableConfig: TableConfig<T>
	tableData: T[]
	onClick?: (id: string | number) => void
	sentryRef: LegacyRef<HTMLDivElement>
	rootRef: LegacyRef<HTMLDivElement>
	// minTableWidth: string
	loading: boolean
	hasNextPage: boolean
}

const StyledLoading = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'center',
	padding: '20px 0',
}))
type StyledReferralLinkTableProps = {
	// minTableWidth: string
}

const StyledReferralLinkTable = styled('div')<StyledReferralLinkTableProps>(
	({ theme }) => ({
		minWidth: '355px',
		height: 'calc(100vh - 260px)',
		'.table-wrap': {
			overflowX: 'auto',
			overflowY: 'auto',
			// height: 'calc(100vh - 260px)',
			height: '100%',
			'&': {
				scrollbarWidth: 'auto',
				scrollbarColor: 'rgba(0, 0, 0, 0.4) #ffffff',
			},

			'&::-webkit-scrollbar': {
				width: '16px',
			},

			'&::-webkit-scrollbar-track': {
				background: '#ffffff',
			},

			'&::-webkit-scrollbar-thumb': {
				backgroundColor: 'rgba(0, 0, 0, 0.4)',
				borderRadius: '10px',
				border: '3px solid #ffffff',
			},
		},
		'.table-header': {
			position: 'sticky',
			top: '0',
			zIndex: 10,
			display: 'grid',
			gridTemplateColumns:
				'minmax(200px, 1fr) minmax(110px, 1fr) minmax(160px, 1fr) minmax(80px, 100px)',
		},
		'.table-body': {
			// height: '400px',
			// maxHeight: '425px',
			// height: '100%',
			// maxHeight: '100%',
		},
		[theme.breakpoints.down('md')]: {
			height: 'calc(100vh - 310px)',
		},
		[theme.breakpoints.down('sm')]: {
			height: 'calc(100vh - 340px)',

			'.table-header': {
				gridTemplateColumns:
					'minmax(170px, 1fr) minmax(80px, 1fr) minmax(130px, 1fr)  minmax(60px, 1fr)',
			},
		},
	}),
)

const ReferralLinkTable = <T extends { extId?: string; id?: string | number }>({
	tableConfig,
	tableData,
	rootRef,
	sentryRef,
	onClick,
	// minTableWidth,
	loading,
	hasNextPage,
}: ReferralLinkTableProps<T>) => {
	// const tableBodyRef = useRef<HTMLDivElement | null>(null)
	// const tableRef = useRef<HTMLDivElement | null>(null)

	// const hasScroll = true

	// useScrollBar(tableBodyRef, hasScroll)
	// useScrollBar(tableRef, hasScroll)
	const isExistOnClick = useMemo(() => Boolean(onClick), [onClick])

	return (
		<StyledReferralLinkTable>
			<div className="table-wrap" ref={rootRef}>
				<RefLinkTableHeader tableConfig={tableConfig} />
				<div
					className="table-body"

					// style={{ height: hasScroll ? '435px' : 'auto' }}
				>
					{tableData.map((rowData, rowIndex) => (
						<TableRow<T>
							// sentryRef={sentryRef}
							key={rowData.extId || rowData.id}
							rowData={rowData}
							rowIndex={rowIndex}
							tableConfig={tableConfig}
							isExistOnClick={isExistOnClick}
							onClick={onClick}
						/>
					))}
					{(loading || hasNextPage) && (
						<StyledLoading ref={sentryRef}>
							<CircularProgress />
						</StyledLoading>
					)}
				</div>
			</div>
		</StyledReferralLinkTable>
	)
}

export default ReferralLinkTable
